<template>
  <section>
    <b-loading data-cy="LOADING" :active="isLoading" />
    <b-collapse
      data-cy="FILE_NO_EDITABLE"
      aria-id="docProcessDispatch"
      class="collapse-custom mt-20"
      animation="slide"
      :open="Boolean(getModifiedDispatchFiles.length)"
    >
      <template #trigger="props">
        <div
          class="has-text-weight-semibold is-flex is-align-items-center is-justify-content-space-between"
        >
          <label class="is-flex is-align-items-center">
            <span>
              {{ General.PROCESS_DOCUMENTS }}
            </span>
            <span class="optional-label has-text-weight-bold ml-5">
              {{ General.OPTIONAL }}
            </span>
          </label>
          <b-icon
            size="is-medium"
            :icon="props.open ? 'chevron-up' : 'chevron-down'"
          />
        </div>
      </template>
      <ListAttachments
        v-model="currentPageNoEditable"
        isDispatch
        :onEdit="editFile"
        :documentEditor="documentEditor"
        :showModalUpload="showModalUpload"
        :isSignatureDone="isSignatureDone"
        :processNup="nup"
        tooltipOpenMobile="is-top"
      />
    </b-collapse>

    <b-collapse
      data-cy="FILE_EDITABLE"
      aria-id="docProcessEditableDispatch"
      class="collapse-custom mt-20"
      animation="slide"
      :open="Boolean(getModifiedDispatchFilesEditable.length)"
    >
      <template #trigger="props">
        <div
          class="is-flex is-align-items-center is-justify-content-space-between"
        >
          <label class="has-text-weight-semibold is-flex is-align-items-center">
            <span>{{ General.EDITABLE_FILES }} </span>
            <span class="optional-label has-text-weight-bold ml-5">{{
              General.OPTIONAL
            }}</span>
            <b-tooltip
              multilined
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              :size="isMobile ? 'is-small' : 'is-large'"
              :position="isMobile ? 'is-left' : 'is-right'"
            >
              <template v-slot:content>
                <span class="has-text-weight-semibold is-flex">{{
                  App.MenuMain.HELP
                }}</span>
                <p class="has-text-left">
                  {{ General.TEXTS.TIP_EDITABLES_FILES }}
                </p>
              </template>
              <div class="is-flex">
                <b-icon
                  class="spacing-ml-10"
                  :type="isContrast ? 'is-white' : 'is-blue-oil'"
                  size="is-small"
                  icon="information"
                />
              </div>
            </b-tooltip>
          </label>
          <b-icon
            size="is-medium"
            :icon="props.open ? 'chevron-up' : 'chevron-down'"
          />
        </div>
      </template>
      <div class="spacing-pr-15">
        <ListAttachments
          v-model="currentPageEditable"
          isDispatchEditable
          :onEdit="editFile"
          :showModalUpload="showModalUpload"
          :editableDocument="editableDocument"
          :documentEditor="documentEditor"
          :isSignatureDone="isSignatureDone"
          :processNup="nup"
          tooltipOpenMobile="is-top"
        />
      </div>
    </b-collapse>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { App, General } from "@/utils/constants";
import ListAttachments from "@/components/ListAttachments";
import { ATTACHEMENT_MAX_COUNT } from "@/utils/enumerate";

export default {
  name: "ProcessDetailDocumentDispatch",
  components: {
    ListAttachments
  },
  props: {
    showModalUpload: {
      type: Function,
      default: () => null
    },
    documentEditor: {
      type: Function,
      default: () => null
    },
    editableDocument: {
      type: Function,
      default: () => null
    },
    editFile: {
      type: Function,
      default: () => null
    },
    nup: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      App,
      General,
      currentPageNoEditable: 1,
      currentPageEditable: 1,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      getModifiedDispatchFilesEditable: "getModifiedDispatchFilesEditable",
      getModifiedDispatchFiles: "getModifiedDispatchFiles",
      initialFile: "getDispatchInitialFile",
      getDispatch: "getDispatch",
      user: "getCurrentUser",
      isContrast: "isContrast",
      isMobile: "isMobile"
    }),
    dispatchInitialFile() {
      return this.initialFile(this.getDispatch.id) || { status: "" };
    },
    isSignatureDone() {
      return this.dispatchInitialFile?.sign_history?.some(
        history =>
          history.user_id !== this.user.id &&
          history.status.includes("SIGNED") &&
          !history.only_historical
      );
    }
  },
  watch: {
    async currentPageNoEditable(newPage) {
      this.isLoading = true;
      await this.dispatchFileRequest({
        dispatchId: this.getDispatch.id,
        page: newPage,
        paginator_count: ATTACHEMENT_MAX_COUNT
      });
      this.isLoading = false;
    },
    async currentPageEditable(newPage) {
      this.isLoading = true;
      await this.dispatchFileRequest({
        dispatchId: this.getDispatch.id,
        editable: true,
        page: newPage,
        paginator_count: ATTACHEMENT_MAX_COUNT
      });
      this.isLoading = false;
    }
  },
  methods: {
    ...mapActions(["dispatchFileRequest"])
  }
};
</script>

<style lang="scss" scoped>
.optional-label {
  font-size: 10px;
  font-weight: 300;
  color: #888;
}
</style>
